function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { FilterOptionsBar } from "./styles";
import { FilterOptions, TemplateTypeWrapper } from "../NoteTemplatesModal/styles";
import MultiDropdownSelect from "../../core/input/MultiDropdownSelect";
import DropdownSelect from "../../core/input/DropdownSelect";
import PillSelectorCheckboxes from "../../style/pillSelectorCheckboxes";
import SearchInput from "../../core/input/SearchInput";
import ToggleFilterButton from "./ToggleFilterButton/ToggleFilterButton";
import useDebouncedState from "../../../hooks/useDebouncedState";
import { ARCHIVED_OPTIONS, TEMPLATE_TYPE_OPTIONS, ADMIN_TEMPLATE_VALUE, RECRUITMENT_PARTNER_TEMPLATE_VALUE } from "../consts";
var arrayEquals = function arrayEquals(array1, array2) {
  if (!array1 && !array2) return true;
  if (!array1 || !array2) return false;
  if (array1.length !== array2.length) return false;
  var a1 = array1.slice().sort();
  var a2 = array2.slice().sort();
  return a1.every(function (value, index) {
    return value === a2[index];
  });
};
var NoteTemplatesFilter = function NoteTemplatesFilter(_ref) {
  var categories = _ref.categories,
    filter_archived = _ref.filter_archived,
    filter_categories = _ref.filter_categories,
    filter_for_agents = _ref.filter_for_agents,
    filter_for_students = _ref.filter_for_students,
    filter_restricted = _ref.filter_restricted,
    filter_tags = _ref.filter_tags,
    filter_template_types = _ref.filter_template_types,
    handleArchivedChange = _ref.handleArchivedChange,
    handleCategoryChange = _ref.handleCategoryChange,
    handleForAgentsChange = _ref.handleForAgentsChange,
    handleForStudentsChange = _ref.handleForStudentsChange,
    handleRestrictedChange = _ref.handleRestrictedChange,
    handleTagChange = _ref.handleTagChange,
    handleTemplateTypesChange = _ref.handleTemplateTypesChange,
    onSearchValueChange = _ref.onSearchValueChange,
    onlyShowAdminType = _ref.onlyShowAdminType,
    searchValue = _ref.searchValue,
    tags = _ref.tags,
    forceEnabledTypeDropdown = _ref.forceEnabledTypeDropdown,
    _ref$overiddenPermiss = _ref.overiddenPermissions,
    overiddenPermissions = _ref$overiddenPermiss === void 0 ? {} : _ref$overiddenPermiss,
    permissions = _ref.permissions;
  var _useDebouncedState = useDebouncedState({
      agent: filter_for_agents,
      archived: 'false',
      categories: filter_categories,
      restricted: filter_restricted,
      student: filter_for_students,
      tags: filter_tags,
      text: searchValue,
      type: filter_template_types[0] || (permissions.create_public_note_from_admin_template || permissions.create_private_note_from_template ? ADMIN_TEMPLATE_VALUE : RECRUITMENT_PARTNER_TEMPLATE_VALUE)
    }, 400),
    _useDebouncedState2 = _slicedToArray(_useDebouncedState, 3),
    filters = _useDebouncedState2[0],
    debouncedFilters = _useDebouncedState2[1],
    setFilters = _useDebouncedState2[2];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var onToggleExpanded = useCallback(function () {
    return setExpanded(function (e) {
      return !e;
    });
  }, [setExpanded]);
  var onTextChange = useCallback(function (event) {
    var value = event.target.value;
    setFilters(function (originalValue) {
      return _objectSpread(_objectSpread({}, originalValue), {}, {
        text: value
      });
    });
  }, [setFilters]);
  var onCategoryChange = useCallback(function (value) {
    setFilters(function (originalValue) {
      return _objectSpread(_objectSpread({}, originalValue), value);
    });
  }, [setFilters]);
  var onTagChange = useCallback(function (value) {
    setFilters(function (originalValue) {
      return _objectSpread(_objectSpread({}, originalValue), value);
    });
  }, [setFilters]);
  var onTypeChange = useCallback(function (type) {
    setFilters(function (originalValue) {
      return _objectSpread(_objectSpread({}, originalValue), {}, {
        type: type
      });
    });
  }, [setFilters]);
  var onAgentsChange = useCallback(function (event) {
    var value = event.target.checked;
    setFilters(function (originalValue) {
      return _objectSpread(_objectSpread({}, originalValue), {}, {
        agent: value
      });
    });
  }, [setFilters]);
  var onStudentsChange = useCallback(function (event) {
    var value = event.target.checked;
    setFilters(function (originalValue) {
      return _objectSpread(_objectSpread({}, originalValue), {}, {
        student: value
      });
    });
  }, [filters, setFilters]);
  var onRestrictedChange = useCallback(function (event) {
    var value = event.target.checked;
    setFilters(function (originalValue) {
      return _objectSpread(_objectSpread({}, originalValue), {}, {
        restricted: value
      });
    });
  }, [filters, setFilters]);
  var onArchivedChanged = useCallback(function (archived) {
    setFilters(function (originalValue) {
      return _objectSpread(_objectSpread({}, originalValue), {}, {
        archived: archived
      });
    });
  }, [setFilters]);
  var isActive = useMemo(function () {
    return filters.categories && filters.categories.length > 0 || filters.tags && filters.tags.length > 0 || filters.agent || filters.student || filters.restricted;
  }, [filters]);
  useEffect(function () {
    if (searchValue !== debouncedFilters.text) {
      onSearchValueChange({
        target: {
          value: debouncedFilters.text
        }
      });
    }
    if (!arrayEquals(filter_categories, debouncedFilters.categories)) {
      handleCategoryChange(debouncedFilters.categories);
    }
    if (!arrayEquals(filter_tags, debouncedFilters.tags)) {
      handleTagChange(debouncedFilters.tags);
    }
    if (filter_for_agents !== debouncedFilters.agent) {
      handleForAgentsChange(debouncedFilters.agent);
    }
    if (filter_for_students !== debouncedFilters.student) {
      handleForStudentsChange(debouncedFilters.student);
    }
    if (filter_restricted !== debouncedFilters.restricted) {
      handleRestrictedChange(debouncedFilters.restricted);
    }
    if (filter_template_types[0] !== debouncedFilters.type) {
      handleTemplateTypesChange([debouncedFilters.type]);
    }
    if (filter_archived !== debouncedFilters.archived) {
      handleArchivedChange(debouncedFilters.archived);
    }
  }, [debouncedFilters, filter_archived, filter_categories, filter_for_agents, filter_for_students, filter_restricted, filter_tags, searchValue]);
  var combinedPermissions = useMemo(function () {
    return _objectSpread(_objectSpread({}, permissions), overiddenPermissions);
  }, [permissions, overiddenPermissions]);
  var showNoteTemplateTypeFilter = useMemo(function () {
    return forceEnabledTypeDropdown || combinedPermissions.filter_note_template && (combinedPermissions.create_public_note_from_admin_template || combinedPermissions.create_public_note_from_agent_template || combinedPermissions.create_private_note_from_template);
  }, [permissions, overiddenPermissions]);
  var canFilterTemplateType = forceEnabledTypeDropdown || (combinedPermissions.create_private_note_from_template || combinedPermissions.create_public_note_from_admin_template) && combinedPermissions.create_public_note_from_agent_template;
  var showPillFilter = useMemo(function () {
    return debouncedFilters.type !== 'agent';
  }, [debouncedFilters]);
  useEffect(function () {
    // if the pill becomes hidden, then deselect the options
    if (!showPillFilter) {
      setFilters(function (originalValue) {
        return _objectSpread(_objectSpread({}, originalValue), {}, {
          student: false,
          agent: false,
          restricted: false
        });
      });
    }
  }, [showPillFilter, setFilters]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FilterOptions, null, /*#__PURE__*/React.createElement(SearchInput, {
    "aria-label": "Search templates",
    inputValue: filters.text,
    onChange: onTextChange
  }), combinedPermissions.filter_note_template && /*#__PURE__*/React.createElement(ToggleFilterButton, {
    onClick: onToggleExpanded,
    has_filters: isActive
  })), expanded && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FilterOptions, null, /*#__PURE__*/React.createElement(FilterOptionsBar, null, /*#__PURE__*/React.createElement(MultiDropdownSelect, {
    clearable: true,
    noPadding: true,
    removeSelected: false,
    iden: "categories",
    labelText: "Categories",
    placeholder: "Select Categories...",
    type: "select",
    inputValue: filters.categories,
    onChange: onCategoryChange,
    options: categories,
    className: "dropdown-multi-select-wrapper",
    elementClassName: "dropdown-multi-select"
  }), /*#__PURE__*/React.createElement(MultiDropdownSelect, {
    clearable: true,
    noPadding: true,
    removeSelected: false,
    iden: "tags",
    labelText: "Tags",
    placeholder: "Select Tags...",
    type: "select",
    inputValue: filters.tags,
    onChange: onTagChange,
    options: tags,
    className: "dropdown-multi-select-wrapper",
    elementClassName: "dropdown-multi-select"
  }), showNoteTemplateTypeFilter && /*#__PURE__*/React.createElement(TemplateTypeWrapper, null, /*#__PURE__*/React.createElement(DropdownSelect, {
    noPadding: true,
    placeholder: "Select Template Types...",
    type: "select",
    inputValue: filters.type,
    onChange: onTypeChange,
    options: TEMPLATE_TYPE_OPTIONS,
    className: "dropdown-multi-select-wrapper",
    elementClassName: "dropdown-multi-select",
    disabled: !canFilterTemplateType
  })), /*#__PURE__*/React.createElement(TemplateTypeWrapper, null, /*#__PURE__*/React.createElement(DropdownSelect, {
    className: "dropdown-multi-select-wrapper",
    disabled: onlyShowAdminType,
    elementClassName: "dropdown-multi-select",
    inputValue: filters.archived,
    noPadding: true,
    onChange: onArchivedChanged,
    options: ARCHIVED_OPTIONS,
    placeholder: "",
    type: "select"
  })))), /*#__PURE__*/React.createElement(FilterOptions, null, showPillFilter && /*#__PURE__*/React.createElement(PillSelectorCheckboxes, null, /*#__PURE__*/React.createElement("span", {
    className: "pill"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "filter-for-agents",
    checked: filters.agent,
    onChange: onAgentsChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "filter-for-agents"
  }, "For Recruitment Partners")), /*#__PURE__*/React.createElement("span", {
    className: "pill"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "filter-for-students",
    checked: filters.student,
    onChange: onStudentsChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "filter-for-students"
  }, "For Students")), /*#__PURE__*/React.createElement("span", {
    className: "pill"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "filter-for-restricted",
    checked: filters.restricted,
    onChange: onRestrictedChange
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "filter-for-restricted"
  }, "Private Notes"))))));
};
export default NoteTemplatesFilter;